if (typeof boostPFSThemeConfig !== 'undefined') {
  // Override Settings



  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      /* Optional */
      loadProductFirst: true,
    },
  };
}

(function() {
  BoostPFS.inject(this);
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item


  

  ProductGridItem.prototype.compileTemplate = function(data, index) {
    
    if (!data) data = this.data;
    if (!index) index = this.index;
  
    
    
    let banner_type = boostPFSConfig.custom.banner_type;
    let banner_type_two = boostPFSConfig.custom.banner_type_two;

    

    
    // ============================ Rasmus 06-08-2025 - test START =============================  


    // if (index === 3) {
    //   // Insert a banner after product at index 2

    //   let fullWidth = boostPFSConfig.custom.show_banner_full_width ? 'collection-banner-full-width' : '';
    //   let showShowVideo = boostPFSConfig.custom.show_banner_video ? 'show-video' : '';
    //   let banner_type = boostPFSConfig.custom.banner_type;

    //   let bannerHtml = '';
    //   if (banner_type === "image") {
    //   bannerHtml = `
    //     <div class="ProductItem Grid__Cell 1/2--phone 1/2--tablet-and-up 1/3--desk 1/3--tablet-and-up ${fullWidth} promo-banner">
    //     <div class="ProductItem">
    //       <a id="${ boostPFSConfig.custom.show_banner_tracking_id }" href="${ boostPFSConfig.custom.show_banner_url }" class="ProductItem__ImageWrapper ProductItem__ImageWrapper--withAlternateImage collection-banner ${showShowVideo}">
    //       <div class="banner-one-text-wrapper" style="top: ${boostPFSConfig.custom.show_banner_vertical_placement}%; color: ${boostPFSConfig.custom.show_banner_headline_color};">
    //         ${boostPFSConfig.custom.show_banner_headline ? `<p class="promo-banner-headline banner-one-headline">${boostPFSConfig.custom.show_banner_headline}</p>` : ''}  
    //         ${boostPFSConfig.custom.show_banner_text ? `<p class="promo-banner-text banner-one-text">${boostPFSConfig.custom.show_banner_text}</p>` : ''} 
    //       </div>
    //       <img src="${boostPFSConfig.custom.show_banner_image}" alt="Banner" style="width: 100%; height: 100%; object-fit: cover; min-height: 220px;" />
    //       </a>
    //     </div>
    //     </div>
    //   `;
    //   }
    //   if (banner_type === "video") {
    //   bannerHtml = `
    //     <div class="ProductItem Grid__Cell ${fullWidth} promo-banner">
    //     <div class="ProductItem__ImageWrapper ProductItem__ImageWrapper--withAlternateImage">
    //       <a id="${ boostPFSConfig.custom.show_banner_tracking_id }" href="${ boostPFSConfig.custom.show_banner_url }" class="ProductItem__ImageWrapper ProductItem__ImageWrapper--withAlternateImage collection-banner ${showShowVideo}">
    //       <div class="banner-one-text-wrapper" style="top: ${boostPFSConfig.custom.show_banner_vertical_placement}%; color: ${boostPFSConfig.custom.show_banner_headline_color};">
    //         ${boostPFSConfig.custom.show_banner_headline ? `<p class="promo-banner-headline banner-one-headline">${boostPFSConfig.custom.show_banner_headline}</p>` : ''}  
    //         ${boostPFSConfig.custom.show_banner_text ? `<p class="promo-banner-text banner-one-text">${boostPFSConfig.custom.show_banner_text}</p>` : ''} 
    //       </div>
    //       <video autoplay muted loop playsinline class="video-banner" style="width: 100%; height: 100%; object-fit: cover; min-height: 220px;" poster="${boostPFSConfig.custom.show_banner_video_poster}">
    //         <source src="${boostPFSConfig.custom.show_banner_video_url}" type="video/mp4"> 
    //         Your browser does not support the video tag.
    //       </video> 
    //       </a>
    //     </div>
    //     </div>
    //   `;
    //   }

    //   // Render the product as usual, then append the banner
    //   var itemHtml = boostPFSTemplate.productGridItemHtml;
    //   itemHtml = itemHtml.replace(/{{mobile_items_per_row}}/g, boostPFSConfig.custom.mobile_items_per_row);
    //   itemHtml = itemHtml.replace(/{{tablet_items_per_row}}/g, boostPFSConfig.custom.tablet_items_per_row);
    //   itemHtml = itemHtml.replace(/{{desktop_items_per_row}}/g, boostPFSConfig.custom.desktop_items_per_row);
    //   itemHtml = itemHtml.replace(/{{horizontal_class}}/g, boostPFSConfig.custom.horizontal_class);
    //   itemHtml = itemHtml.replace(/{{filter_position_class}}/g, boostPFSConfig.custom.filter_position);

    //   var has_alternate_image = false; 
    //   var images = data.images_info;
    //   if (images.length > 1 &&
    //     boostPFSConfig.custom.hasOwnProperty('product_show_secondary_image') &&
    //     boostPFSConfig.custom.product_show_secondary_image == true) {
    //     has_alternate_image = true;
    //   }
    //   itemHtml = itemHtml.replace(/{{has_alternate_image_class}}/g, has_alternate_image ? "ProductItem__ImageWrapper--withAlternateImage" : ""); 

    //   var use_natural_size = false;
    //   if (boostPFSConfig.custom.hasOwnProperty('product_image_size') &&
    //     boostPFSConfig.custom.product_image_size == 'natural' || boostPFSThemeConfig.custom.use_horizontal) {
    //     use_natural_size = true;
    //   }
    //   var media_aspect_ratio = images[0].width / images[0].height;
    //   var max_width = images[0].width;
    //   if (boostPFSThemeConfig.custom.use_horizontal) max_width = 125;
    //   itemHtml = itemHtml.replace(/{{use_natural_size_class}}/g, use_natural_size ? "withFallback" : boostPFSConfig.custom.product_image_size);
    //   itemHtml = itemHtml.replace(/{{padding_bottom}}/g, use_natural_size ? 'padding-bottom: ' + (100 / media_aspect_ratio) + '%;' : '');
    //   itemHtml = itemHtml.replace(/{{media_aspect_ratio}}/g, media_aspect_ratio);
    //   itemHtml = itemHtml.replace(/{{max_width}}/g, max_width);

    //   var sizes0 = '200,400,600,700,800,900,1000,1200';
    //   var image_url = Utils.optimizeImage(images[0]['src'], '{width}x');
    //   itemHtml = itemHtml.replace(/{{image_url}}/g, image_url);
    //   itemHtml = itemHtml.replace(/{{supported_sizes}}/g, imageSize(sizes0, images[0]));
    //   itemHtml = itemHtml.replace(/{{featured_media_id}}/g, images[0].id);
    //   var featured_media_url = Utils.optimizeImage(images[0]['src'], '600x');
    //   itemHtml = itemHtml.replace(/{{featured_media_url}}/g, featured_media_url);

    //   if (data.available) {
    //     itemHtml = itemHtml.replace(/{{quick_add}}/g, buildQuickAdd(data, index));
    //   } else {
    //     itemHtml = itemHtml.replace(/{{quick_add}}/g, '');
    //   }

    //   var alternate_image = '';
    //   if (has_alternate_image && images.length > 1) {
    //     var sizes1 = '200,300,400,600,800,900,1000,1200';
    //     var thumbUrl = Utils.optimizeImage(images[1]['src'], '{width}x');
    //     alternate_image += '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" data-src="' + thumbUrl + '" data-widths="[' + imageSize(sizes1, images[1]) + ']"  data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[1].id + '">';
    //   }
    //   itemHtml = itemHtml.replace(/{{alternate_image}}/g, alternate_image);

    //   var product_media1_url = featured_media_url;
    //   if (images.length > 1) {
    //     product_media1_url = Utils.optimizeImage(images[1]['src'], '600x');
    //   }
    //   itemHtml = itemHtml.replace(/{{product_media1_url}}/g, product_media1_url);

    //   // Add Label
    //   itemHtml = itemHtml.replace(/{{product_labels}}/g, buildLabels(data));

    //   // Add main attribute (Always put at the end of this function)
    //   itemHtml = itemHtml.replace(/{{product_info}}/g, buildInfo(data, index));

    //   var view_product = boostPFSConfig.custom.use_horizontal ? '<a href="{{itemUrl}}" class="ProductItem__ViewButton Button Button--secondary hidden-pocket">' + boostPFSConfig.label.view_product + '</a>' : '';
    //   itemHtml = itemHtml.replace(/{{view_product}}/g, view_product);

    //   // Add Reviews
    //   if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
    //     var itemReviews = ''
    //     if (boostPFSConfig.custom.show_product_rating && !boostPFSConfig.custom.use_horizontal) {
    //       itemReviews += '<div class="ProductItem__Rating Heading Text--subdued u-h7">';
    //       var ratingInfo = Utils.getProductMetafield(data, 'reviews', 'rating') || '';
    //       var ratingValue = '';
    //       if (ratingInfo != '') {
    //         ratingInfo = JSON.parse(ratingInfo);
    //         ratingValue = ratingInfo.value;
    //         var rating_decimal = 0;
    //         var decimal = ratingValue % 1;
    //         if (decimal >= 0.3 && decimal <= 0.7) {
    //           rating_decimal = 0.5;
    //         } else if (decimal > 0.7) {
    //           rating_decimal = 1;
    //         }

    //         itemReviews += '<div class="rating">';
    //         itemReviews += '<div class="rating__stars" role="img" aria-label="';
    //         itemReviews += boostPFSConfig.label.star_reviews_info.replace(/{{rating_value}}/g, ratingValue).replace(/{{rating_max}}/g, ratingInfo.scale_max);
    //         itemReviews += '">';

    //         var rating_as_float = ratingValue * 1.0;
    //         var i;
    //         for (i = ratingInfo.scale_min; i <= ratingInfo.scale_max; i++) {
    //           if (rating_as_float >= i) {
    //             itemReviews += boostPFSConfig.custom.rating_star_full;
    //           } else {
    //             if (rating_decimal == 0.5) {
    //               itemReviews += boostPFSConfig.custom.rating_star_half;
    //             } else if (rating_decimal == 1) {
    //               itemReviews += boostPFSConfig.custom.rating_star_full;
    //             } else {
    //               itemReviews += boostPFSConfig.custom.rating_star_empty;
    //             }
    //             rating_decimal = false;
    //           }

    //         }

    //         itemReviews += '</div>';
    //         var rating_count = Utils.getProductMetafield(data, 'reviews', 'rating_count') || '';

    //         if (rating_count != '') {
    //           itemReviews += '<span class="rating__caption">' + boostPFSConfig.label.reviews_count.replace(/{{ count }}/g, rating_count) + '</span>';
    //         } else {
    //           itemReviews += '<span class="rating__caption">' + boostPFSConfig.label.reviews_count.replace(/{{ count }}/g, 0) + '</span>'
    //         }

    //         itemReviews += '</div>';
    //       } else {
    //         itemReviews += '<div class="rating">';
    //         itemReviews += '<div class="rating__stars" role="img" aria-label="';
    //         itemReviews += boostPFSConfig.label.star_reviews_info.replace(/{{ rating_value }}/g, 0).replace(/{{ rating_max }}/g, 5);
    //         itemReviews += '">';
    //         var j;
    //         for (j = 0; j < 5; j++) {
    //           itemReviews += boostPFSConfig.custom.rating_star_empty;
    //         }
    //         itemReviews += '</div>';
    //         itemReviews += '<span class="rating__caption">' + boostPFSConfig.label.reviews_count.replace(/{{ count }}/g, 0) + '</span>'
    //         itemReviews += '</div>';
    //       }
    //     }
    //     itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviews);
    //   }
    //   itemHtml = itemHtml.replace(/{{buildClassHiz}}/g, buildClassHiz());
    //   itemHtml = itemHtml.replace(/{{buildClass}}/g, buildClass());
    //   itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));

    //   return itemHtml + bannerHtml;
    // }




    
    // ============================ Rasmus 06-08-2025 - test END =============================  
















    
    // RASMUS 06-05-2025  // Insert a banner at product #4 (index === 3)

  //   if (banner_type !== 'hide') { 
     
  //     if (index === boostPFSConfig.custom.show_banner_index) {
  //        console.log ('in banner type hide 2');
  //       let fullWidth = boostPFSConfig.custom.show_banner_full_width ? 'collection-banner-full-width' : '';
  //       let showShowVideo = boostPFSConfig.custom.show_banner_video ? 'show-video' : '';
  //       let banner_type = boostPFSConfig.custom.banner_type;
  //       return `
  //         <div class="ProductItem Grid__Cell 1/2--phone 1/2--tablet-and-up 1/3--desk 1/3--tablet-and-up ${fullWidth} promo-banner">
  //           <div class="ProductItem__ImageWrapper ProductItem__ImageWrapper--withAlternateImage">
            
  //         <a id="${ boostPFSConfig.custom.show_banner_tracking_id }" href="${ boostPFSConfig.custom.show_banner_url }" class="ProductItem__ImageWrapper ProductItem__ImageWrapper--withAlternateImage collection-banner ${showShowVideo}">
  //             <div class="banner-one-text-wrapper" style="top: ${boostPFSConfig.custom.show_banner_vertical_placement}%; color: ${boostPFSConfig.custom.show_banner_headline_color};">
  //              ${boostPFSConfig.custom.show_banner_headline ? `<p class="promo-banner-headline banner-one-headline">${boostPFSConfig.custom.show_banner_headline}</p>` : ''}  
  //             ${boostPFSConfig.custom.show_banner_text ? `<p class="promo-banner-text banner-one-text">${boostPFSConfig.custom.show_banner_text}</p>` : ''}
               
  //             </div>
  //             ${banner_type === "image" ? `
  //               <img src="${boostPFSConfig.custom.show_banner_image}" alt="Banner" style="width: 100%; height: 100%; object-fit: cover; min-height: 220px;" />
  //             ` : ''}
              
  //             ${banner_type === "video" ? `
  //               <video autoplay muted loop playsinline class="video-banner" style="width: 100%; height: 100%; object-fit: cover; min-height: 220px;" poster="${boostPFSConfig.custom.show_banner_video_poster}">
  //                 <source src="${boostPFSConfig.custom.show_banner_video_url}" type="video/mp4"> 
  //                 Your browser does not support the video tag.
  //               </video> 
  //             ` : ''}
  //         </a>
  //           </div>
  //         </div>
  //       `;
  //     } 
    
  // }

    // BAMMER TWO 06-05-2025 START

  
// Render banner_type_two only once per product list render
// if (banner_type_two !== 'hide') {
//   // Use a static property on the function to track rendering
//   if (!ProductGridItem._bannerTwoRendered && index === boostPFSConfig.custom.show_banner_index_two) {
//     ProductGridItem._bannerTwoRendered = true;
//     console.log('in banner type hide 2');
//     let fullWidth_two = boostPFSConfig.custom.show_banner_full_width_two ? 'collection-banner-full-width' : '';
//     let showShowVideo_two = boostPFSConfig.custom.show_banner_video_two ? 'show-video' : '';
//     let banner_type_two = boostPFSConfig.custom.banner_type_two;
//     return `
//       <div class="ProductItem Grid__Cell 1/2--phone 1/2--tablet-and-up 1/3--desk 1/3--tablet-and-up ${fullWidth_two} promo-banner">
//         <div class="ProductItem__ImageWrapper ProductItem__ImageWrapper--withAlternateImage">
//           <a id="${boostPFSConfig.custom.show_banner_tracking_id_two}" href="${boostPFSConfig.custom.show_banner_url_two}" class="ProductItem__ImageWrapper ProductItem__ImageWrapper--withAlternateImage collection-banner ${showShowVideo_two}">
//             <div class="banner-one-text-wrapper" style="top: ${boostPFSConfig.custom.show_banner_two_vertical_placement}%; color: ${boostPFSConfig.custom.show_banner_two_headline_color};">
//               ${boostPFSConfig.custom.show_banner_two_headline ? `<p class="promo-banner-headline banner-one-headline">${boostPFSConfig.custom.show_banner_two_headline}</p>` : ''}  
//               ${boostPFSConfig.custom.show_banner_two_text ? `<p class="promo-banner-text banner-one-text">${boostPFSConfig.custom.show_banner_two_text}</p>` : ''}
//             </div>
//             ${banner_type_two === "image" ? `
//               <img src="${boostPFSConfig.custom.show_banner_image_two}" alt="Banner" style="width: 100%; height: 100%; object-fit: cover; min-height: 220px;" />
//             ` : ''}
//             ${banner_type_two === "video" ? `
//               <video autoplay muted loop playsinline class="video-banner" style="width: 100%; height: 100%; object-fit: cover; min-height: 220px;" poster="${boostPFSConfig.custom.show_banner_video_poster}">
//                 <source src="${boostPFSConfig.custom.show_banner_video_url_two}" type="video/mp4"> 
//                 Your browser does not support the video tag.
    //               </video> 
    //             ` : ''} 
    //           </a>
    //         </div>
    //       </div> 
    //     `;
    //   }
    //   // Reset the flag when starting a new render (optional, depends on your render cycle)
    //   if (index === 0) {
    //     ProductGridItem._bannerTwoRendered = false;
    //   }


    // }






    // BAMMER TWO 06-05-2025 END












    

    // Default product rendering for other products
    var soldOut = !data.available,
      available = data.available,
      onSale = data.compare_at_price_min > data.price_min,
      priceVaries = data.price_min != data.price_max,
      images = data.images_info;

    if (images.length == 0) {
      images.push({
        src: boostPFSConfig.general.no_image_url, 
        id: data.id,
        width: 480,
        height: 480
      });
    }

    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    // Add class
    itemHtml = itemHtml.replace(/{{mobile_items_per_row}}/g, boostPFSConfig.custom.mobile_items_per_row);
    itemHtml = itemHtml.replace(/{{tablet_items_per_row}}/g, boostPFSConfig.custom.tablet_items_per_row);
    itemHtml = itemHtml.replace(/{{desktop_items_per_row}}/g, boostPFSConfig.custom.desktop_items_per_row);
    itemHtml = itemHtml.replace(/{{horizontal_class}}/g, boostPFSConfig.custom.horizontal_class);
    itemHtml = itemHtml.replace(/{{filter_position_class}}/g, boostPFSConfig.custom.filter_position);

    var has_alternate_image = false; 
    if (images.length > 1 &&
      boostPFSConfig.custom.hasOwnProperty('product_show_secondary_image') &&
      boostPFSConfig.custom.product_show_secondary_image == true) {
      has_alternate_image = true;
    }
    itemHtml = itemHtml.replace(/{{has_alternate_image_class}}/g, has_alternate_image ? "ProductItem__ImageWrapper--withAlternateImage" : ""); 


    var use_natural_size = false;
    if (boostPFSConfig.custom.hasOwnProperty('product_image_size') &&
      boostPFSConfig.custom.product_image_size == 'natural' || boostPFSThemeConfig.custom.use_horizontal) {
      use_natural_size = true;
    }
    itemHtml = itemHtml.replace(/{{use_natural_size_class}}/g, use_natural_size ? "withFallback" : boostPFSConfig.custom.product_image_size);
    var media_aspect_ratio = images[0].width / images[0].height;
    var max_width = images[0].width;
    if (boostPFSThemeConfig.custom.use_horizontal) max_width = 125;
    itemHtml = itemHtml.replace(/{{padding_bottom}}/g, use_natural_size ? 'padding-bottom: ' + (100 / media_aspect_ratio) + '%;' : '');
    itemHtml = itemHtml.replace(/{{media_aspect_ratio}}/g, media_aspect_ratio);
    itemHtml = itemHtml.replace(/{{max_width}}/g, max_width);

    var sizes0 = '200,400,600,700,800,900,1000,1200';
    var image_url = Utils.optimizeImage(images[0]['src'], '{width}x');
    itemHtml = itemHtml.replace(/{{image_url}}/g, image_url);
    itemHtml = itemHtml.replace(/{{supported_sizes}}/g, imageSize(sizes0, images[0]));
    itemHtml = itemHtml.replace(/{{featured_media_id}}/g, images[0].id);
    var featured_media_url = Utils.optimizeImage(images[0]['src'], '600x');
    itemHtml = itemHtml.replace(/{{featured_media_url}}/g, featured_media_url);
    if (available) {
      itemHtml = itemHtml.replace(/{{quick_add}}/g, buildQuickAdd(data, index));
    } else {
      itemHtml = itemHtml.replace(/{{quick_add}}/g, '');
    }

    var alternate_image = '';

    if (has_alternate_image && images.length > 1) {
      var sizes1 = '200,300,400,600,800,900,1000,1200';
      var thumbUrl = Utils.optimizeImage(images[1]['src'], '{width}x');
      alternate_image += '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" data-src="' + thumbUrl + '" data-widths="[' + imageSize(sizes1, images[1]) + ']"  data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[1].id + '">';
    }
    itemHtml = itemHtml.replace(/{{alternate_image}}/g, alternate_image);

    var product_media1_url = featured_media_url;
    if (images.length > 1) {
      product_media1_url = Utils.optimizeImage(images[1]['src'], '600x');
    }
    itemHtml = itemHtml.replace(/{{product_media1_url}}/g, product_media1_url);

    // Add Label
    itemHtml = itemHtml.replace(/{{product_labels}}/g, buildLabels(data));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{product_info}}/g, buildInfo(data, index));

    var view_product = boostPFSConfig.custom.use_horizontal ? '<a href="{{itemUrl}}" class="ProductItem__ViewButton Button Button--secondary hidden-pocket">' + boostPFSConfig.label.view_product + '</a>' : '';
    itemHtml = itemHtml.replace(/{{view_product}}/g, view_product);

    // Add Reviews
    if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
      var itemReviews = ''
      if (boostPFSConfig.custom.show_product_rating && !boostPFSConfig.custom.use_horizontal) {
        itemReviews += '<div class="ProductItem__Rating Heading Text--subdued u-h7">';
        var ratingInfo = Utils.getProductMetafield(data, 'reviews', 'rating') || '';
        var ratingValue = '';
        if (ratingInfo != '') {
          ratingInfo = JSON.parse(ratingInfo);
          ratingValue = ratingInfo.value;
          var rating_decimal = 0;
          var decimal = ratingValue % 1;
          if (decimal >= 0.3 && decimal <= 0.7) {
            rating_decimal = 0.5;
          } else if (decimal > 0.7) {
            rating_decimal = 1;
          }

          itemReviews += '<div class="rating">';
          itemReviews += '<div class="rating__stars" role="img" aria-label="';
          itemReviews += boostPFSConfig.label.star_reviews_info.replace(/{{rating_value}}/g, ratingValue).replace(/{{rating_max}}/g, ratingInfo.scale_max);
          itemReviews += '">';

          var rating_as_float = ratingValue * 1.0;
          var i;
          for (i = ratingInfo.scale_min; i <= ratingInfo.scale_max; i++) {
            if (rating_as_float >= i) {
              itemReviews += boostPFSConfig.custom.rating_star_full;
            } else {
              if (rating_decimal == 0.5) {
                itemReviews += boostPFSConfig.custom.rating_star_half;
              } else if (rating_decimal == 1) {
                itemReviews += boostPFSConfig.custom.rating_star_full;
              } else {
                itemReviews += boostPFSConfig.custom.rating_star_empty;
              }
              rating_decimal = false;
            }

          }

          itemReviews += '</div>';
          var rating_count = Utils.getProductMetafield(data, 'reviews', 'rating_count') || '';

          if (rating_count != '') {
            itemReviews += '<span class="rating__caption">' + boostPFSConfig.label.reviews_count.replace(/{{ count }}/g, rating_count) + '</span>';
          } else {
            itemReviews += '<span class="rating__caption">' + boostPFSConfig.label.reviews_count.replace(/{{ count }}/g, 0) + '</span>'
          }

          itemReviews += '</div>';
        } else {
          itemReviews += '<div class="rating">';
          itemReviews += '<div class="rating__stars" role="img" aria-label="';
          itemReviews += boostPFSConfig.label.star_reviews_info.replace(/{{ rating_value }}/g, 0).replace(/{{ rating_max }}/g, 5);
          itemReviews += '">';
          var j;
          for (j = 0; j < 5; j++) {
            itemReviews += boostPFSConfig.custom.rating_star_empty;
          }
          itemReviews += '</div>';
          itemReviews += '<span class="rating__caption">' + boostPFSConfig.label.reviews_count.replace(/{{ count }}/g, 0) + '</span>'
          itemReviews += '</div>';
        }
      }
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviews);
    }
    itemHtml = itemHtml.replace(/{{buildClassHiz}}/g, buildClassHiz());
    itemHtml = itemHtml.replace(/{{buildClass}}/g, buildClass());
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));

    return itemHtml;
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildClass() {
    return boostPFSConfig.custom.filter_position == 'drawer' ? 'lap-and-up' : 'desk';
  }

  function buildClassHiz() {
    return boostPFSConfig.custom.use_horizontal ? 'ProductItem--horizontal' : '';
  }


  function buildQuickAdd(data, index) {

    const quickAddContentId = `quick-add-content-${data.id}-${index}`;

    const variantSize = (index) => {

      let html = '';
      let selected = false;


      function availabilityAndChecked(variant) {

        if (!variant.available) {
          return 'disabled'
        }
        else if (!selected) {
          selected = true
          return 'checked="checked"'
        }
        return
      }

      data.variants.forEach(variant => {
        const title = variant.title ;
        const title_size = title.length  ;
        //times: 0.6 changes the width between the numbers
        const text_lenght = title_size * 0.6;

        let viewbox_x = 40;
        const viewbox_y = 24;

        if (title_size > 4){
          const devider = title_size - 4;
          const percentage = devider / 4;
          viewbox_x = (viewbox_x * percentage) + viewbox_x;
        }
        if(variant.available) 
        {
          
          html += `<li class="HorizontalList__Item">
        
          <input class="SizeSwatch__Radio" type="radio" name="${ data.id }-${ index }" id="${ variant.id }-${ index }" value="${ variant.title }"
          ${ availabilityAndChecked(variant) } 
          data-variant-id="${ variant.id }" 
          data-price="${ variant.price }" data-compare-at-price="${ variant.compare_at_price }">  
            <label class="SizeSwatch SizeSwatch__Label" for="${ variant.id }-${ index }">          
              <p>${ title }</p>
            </label>
          </li>`
        }
        
        else {
          /*
          html += `<li class="HorizontalList__Item back-in-stock-item SizeSwatch__Label">
                    <a href="/products/${ data.handle }?variant=${variant.id}">
                      <p>${ variant.title }</p>
                    </a></li>`
          */
          if (!data.tags || !data.tags.includes('end-of-sale')) {
            html += `<li class="HorizontalList__Item back-in-stock-item">
            <a href="/products/${ data.handle }?variant=${variant.id}" style="position: absolute; z-index: 999 !important; display: block; height: 100%; width: 100%;" >
            <p>${ variant.title }</p>
            </a>
            </li>`;  
          }
                            
        }
        
      })

      return html
    }


    let quickAddHTML = `
      <div class="quick-add js-quick-add js-quick-add--boost">
        <div class="quick-add__content" id="${quickAddContentId}">
              <ul class="SizeSwatchList HorizontalList HorizontalList--spacingTight">
                  ${ variantSize(data, index) }
              </ul>

              <div class="quick-add__quantitySelector ProductForm__QuantitySelector">
                <div class="QuantitySelector">
                  <button type="button" class="QuantitySelector__Button Link Link--secondary" data-action="decrease-quantity" aria-label="decrease quantity">
                    <svg class="Icon Icon--minus " role="presentation" viewBox="0 0 16 2"><path d="M1,1 L15,1" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
                    </svg>
                  </button>
                  <input type="text" class="QuantitySelector__CurrentQuantity" pattern="[0-9]*" name="quantity" value="1" aria-label="quantity">
                  <button type="button" class="QuantitySelector__Button Link Link--secondary" data-action="increase-quantity" aria-label="increase quantity">
                    <svg class="Icon Icon--plus " role="presentation" viewBox="0 0 16 16"><g stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"><path d="M8,1 L8,15"></path><path d="M1,8 L15,8"></path></g>
                    </svg>
                  </button>
                </div>
              </div>

              <button class="quick-add__add-to-cart Button Button--full Button--primary" aria-label="add to cart">
                <span>{{productGeneralQuickAddSubmit}}</span>
              </button>

          </div>

            <button class="quick-add__open" aria-expanded="false" aria-controls="${quickAddContentId}" aria-label="{{productGeneralQuickAddOpen}}">{{productGeneralQuickAddOpen}}</button>
      </div>
      `

    quickAddHTML = quickAddHTML.replace(/{{productFormQuantity}}/g, window.languages.productFormQuantity);
    quickAddHTML = quickAddHTML.replace(/{{productGeneralQuickAddSubmit}}/g, window.languages.productGeneralQuickAddSubmit);
    quickAddHTML = quickAddHTML.replace(/{{productGeneralQuickAddOpen}}/g, window.languages.productGeneralQuickAddOpen);

    return quickAddHTML;
  }

  function imageSize(sizes, image) {
    if (image) {
      var desired_sizes = sizes.split(',');
      var supported_sizes = '';
      for (var k = 0; k < desired_sizes.length; k++) {
        var size = desired_sizes[k];
        var size_as_int = size * 1;
        if (image.width < size_as_int) { break; }
        supported_sizes = supported_sizes + size + ',';
      }

      if (supported_sizes == '') supported_sizes = image.width;

      if (!jQ.isNumeric(supported_sizes)) {
        supported_sizes = supported_sizes.split(',').join(',');
        supported_sizes = supported_sizes.substring(0, supported_sizes.lastIndexOf(','));
      }
      return supported_sizes;
    } else {
      return '';
    }
  }

  function buildPrice(data) {
    
    var html = '';
    var show_price_on_hover = boostPFSConfig.custom.product_show_price_on_hover;
    var classPriceHover = show_price_on_hover ? 'ProductItem__PriceList--showOnHover' : '';
    html += '<div class="ProductItem__PriceList ' + classPriceHover + ' Heading">';
    
    if (data.compare_at_price_min > data.price_min) {
      if (boostPFSConfig.custom.hasOwnProperty('currency_code_enabled') && boostPFSConfig.custom.currency_code_enabled) {
        html += '<span class="ProductItem__Price Price Price--highlight Text--subdued test">' +  Utils.formatMoney(data.price_min, 'money_with_currency') + '</span> ';
        html += '<span class="ProductItem__Price Price Price--compareAt Text--subdued test 2">' + Utils.formatMoney(data.compare_at_price_min, 'money_with_currency') + '</span>';
      } else {
        html += '<span class="ProductItem__Price Price Price--highlight Text--subdued test 3">' + Utils.formatMoney(data.price_min) + '</span> ';
        html += '<span class="ProductItem__Price Price Price--compareAt Text--subdued test 4">' + Utils.formatMoney(data.compare_at_price_min) + '</span>';
      }

    } else {
      if (data.price_min != data.price_max) {
        if (boostPFSConfig.custom.hasOwnProperty('currency_code_enabled') && boostPFSConfig.custom.currency_code_enabled) {
          html += '<span class="ProductItem__Price Price Text--subdued test 4">' + boostPFSConfig.label.from_price_html.replace(/{{min_price}}/g, Utils.formatMoney(data.price_min, 'money_with_currency')) + '</span>';
        } else {
          html += '<span class="ProductItem__Price Price Text--subdued test 5">' + boostPFSConfig.label.from_price_html.replace(/{{min_price}}/g, Utils.formatMoney(data.price_min)) + '</span>';
        }
      } else {
        if (boostPFSConfig.custom.hasOwnProperty('currency_code_enabled') && boostPFSConfig.custom.currency_code_enabled) {
          html += '<span class="ProductItem__Price Price Text--subdued test 6" data-money-convertible>' + Utils.formatMoney(data.price_min, 'money_with_currency') + '</span>';
        } else {
          html += '<span class="ProductItem__Price Price Text--subdued test 7 " data-money-convertible>' + Utils.formatMoney(data.price_min) + '</span>';
        }
      }
    }

    html += '</div>';
    return html;
  }

  function buildLabels(data) {
    var html = '';
    var product_labels = '';
    if (boostPFSConfig.custom.show_labels) {
      product_labels = '';
      var tags = data.tags;
      for (var k = 0; k < tags.length; k++) {
        var tag = tags[k];
        if (tag.indexOf('__label') != -1) {
          product_labels += '<span class="ProductItem__Label Heading Text--subdued">' + tag.split('__label:')[1] + '</span>';
          break;
        }
      }
      if (data.available) {
        //console.log('data.compare_at_price_min 3 = ', boostPFSConfig.label.sale )
        //console.log('data.price_min = ', data.price_min)
        if (data.compare_at_price_min > data.price_min)
          product_labels += '<span class="ProductItem__Label Heading Text--subdued test">' + boostPFSConfig.label.sale + '</span>';
      } else {
        product_labels += ' <span class="ProductItem__Label Heading Text--subdued ">' + boostPFSConfig.label.sold_out + '</span>';
      }

      if (product_labels != '') {
        html += '<div class="ProductItem__LabelList">';
        html += product_labels;
        html += '</div>';
      }
    }
    return html;
  }

  function buildInfo(data, indx) {
    var html = '';
    if (boostPFSConfig.custom.show_product_info) {
      var infoClass = (!boostPFSConfig.custom.use_horizontal) ? 'ProductItem__Info--' + boostPFSConfig.custom.product_info_alignment : '';
      html += '<div class="ProductItem__Info ' + infoClass + ' ">';
      if (boostPFSConfig.custom.show_vendor) {
        html += '<p class="ProductItem__Vendor Heading">' + data.vendor + '</p>'
      }

      html += '<h2 class="ProductItem__Title Heading">';
      html += '<a href="{{itemUrl}}">' + data.title + '</a>';
      html += '</h2>';
      html += '{{itemReviews}}';
      html += buildPrice(data);
      if (boostPFSConfig.custom.show_color_swatch) {
        html += buildSwatch(data, indx);
      }
      html += '</div>';
    }

    return html;
  }

  function buildSwatch(data, indx) {
    var itemSwatchHtml = '';
    if (boostPFSConfig.custom.show_color_swatch) {
      var color_name = boostPFSConfig.custom.section_id + '-' + data.id + '-' + indx;
      data.options_with_values.forEach(function(option,  index) {
        var option_name = option.name.toLowerCase();
        if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1 || option_name.indexOf('couleur') != -1) {
          var values = '';
          itemSwatchHtml += '<div class="ProductItem__ColorSwatchList">';
          var i = 0;
          data.variants.forEach(function(variant) {
            var temp = variant.merged_options.filter(function(obj) {
              obj = obj.toLowerCase();
              if (obj.indexOf('color') != -1 || obj.indexOf('colour') != -1 || obj.indexOf('couleur') != -1)
                return obj;
            });
            temp = temp[0].split(':');

            var value = temp[1].toLowerCase();
            if (values.indexOf(value) == -1) {
              values = values + ',' + value;
              values = values.split(',');
              var size = '200,400,600,700,800,900,1000,1200';
              var supported_sizes = imageSize(size, variant.image);
              var color_image = Utils.optimizeImage(variant.image);
              var name_color = Utils.slugify(value) + '.png';
              var checked = (i == 0) ? 'checked=checked' : '';
              var imageInfo = null;
              var image_aspect_ratio = 1;
              imageInfo = data.images_info.find(function(imageOb) {
                if (imageOb.src == variant.image) {
                  image_aspect_ratio = imageOb.width / imageOb.height;
                  return imageOb;
                }
              });
              if (!imageInfo) {
                if (data.images_info.length > 0) {
                  imageInfo = data.images_info[0];
                } else {
                  imageInfo = {
                    src: boostPFSConfig.general.no_image_url,
                    id: variant.id,
                    width: 480,
                    height: 480
                  }
                }

              }
              var dataImg = (imageInfo != null) ? '" data-image-url="' + imageInfo.src + '" data-image-widths="[' + supported_sizes + ']" data-image-aspect-ratio="1" data-image-id="' + imageInfo.id + '"' : '';
              var color_input_id = color_name + "-" + values.length;
              var variant_price = variant.price ? variant.price : 0;
              var variant_compare_at_price = variant.compare_at_price ? variant.compare_at_price : 0;
              var url_color = Utils.getFilePath(Utils.slugify(value), Globals.swatchExtension, Settings.getSettingValue('general.swatchImageVersion'));
              itemSwatchHtml += '<div class="ProductItem__ColorSwatchItem">';
              itemSwatchHtml += '<input class="ColorSwatch__Radio" type="radio" ' + checked + ' name="' + color_name + '" id="' + color_input_id + '" value="' + value + '" data-image-aspect-ratio="' + image_aspect_ratio + '" data-variant-price="' + variant_price + '" data-variant-compare-at-price="' + variant_compare_at_price + '" data-variant-url="' + Utils.buildProductItemUrl(data) + '?variant=' + variant.id + '#Image' + imageInfo.id + '"' + dataImg + '>';
              itemSwatchHtml += '<label class="ColorSwatch ColorSwatch--small" for="' + color_input_id + '" style="background-color: ' + value.replace(' ', '').toLowerCase() + '; background-image: url(' + url_color + ')" title="' + value + '" data-tooltip="' + value + '"></label>';
              itemSwatchHtml += '</div>';
              i++;
            }
          });
          itemSwatchHtml += '</div>';
        }
      });
    }
    return itemSwatchHtml;
  }
  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {
      var paginationHtml = boostPFSTemplate.paginateHtml;
      // Build Previous
      var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
      // Build Next
      var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);
      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }
      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }

    return '';
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function() {
    var html = '';
    if (boostPFSConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          var classActive = (Globals.queryParams.sort == k) ? 'is-selected' : '';
          sortingItemsHtml += '<button class="Popover__Value ' + classActive + ' Heading Link Link--primary u-h6" data-value="' + k + '">' + sortingArr[k] + '</button>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function() {
    var topSortingSelector = jQ(Selector.topSorting);
    topSortingSelector.find('.Popover__Value').click(function(e) {
      FilterApi.setParam('sort', jQ(this).data('value'));
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter('sort');
      jQ('.CollectionToolbar__Item--sort').trigger('click');
    });
  }
  /************************** END BUILD TOOLBAR **************************/

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function(data, eventType) {
    if (!data) data = this.data;
    if (!eventType) eventType = this.eventType;
    /**
     *  Call theme function
     *  1. Add var bcPrestigeSections; var bcPrestigeSectionContainer; to assets/theme.min.js
     *  2. In assets/theme.min.js, find var YYY=new XXX.SectionContainer; For example: var e=new o.SectionContainer;
     *  3. Replace var e=new o.SectionContainer; by var e=new o.SectionContainer; var YYY = new XXX.SectionContainer;  bcPrestigeSections = YYY; bcPrestigeSectionContainer = XXX;

    if(typeof bcPrestigeSectionContainer != 'undefined' && typeof bcPrestigeSections != 'undefined'){
    bcPrestigeSections.register("collection", bcPrestigeSectionContainer.CollectionSection);
    bcPrestigeSections.register("search", bcPrestigeSectionContainer.SearchSection);
    }
    */

    // Fix image not load on Instagram browser - initialize swatch image
    jQ(".ProductItem__Info .ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem label.ColorSwatch").click(function() {
      jQ(this).parent().parent().find('label.ColorSwatch').removeClass('active');
      jQ(this).addClass('active');
      var parent = jQ(this).parent();
      var productImage = jQ(this).parent().parent().parent().parent().find('a.ProductItem__ImageWrapper');
      var variantInfo = parent.find('input.ColorSwatch__Radio');
      productImage.find('.AspectRatio .bc-sf-product-swatch-img').remove();
      productImage.find('.AspectRatio').prepend('<img class="bc-sf-product-swatch-img" src="' + variantInfo.data('image-url') + '" />');
      productImage.find('img.ProductItem__Image').hide();
      productImage.attr('href', variantInfo.data('variant-url'));
      var variantPrice = '';
      if (variantInfo.data('variant-compare-at-price') > variantInfo.data('variant-price')) {
        variantPrice += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>'
        variantPrice += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-compare-at-price')) + '</span>';
      } else {
        variantPrice += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>';
      }
      jQ(this).closest('.ProductItem__Wrapper').find('.ProductItem__PriceList').html(variantPrice);
    })

    //Change view layout
    var desktopView = jQ('.CollectionToolbar__LayoutSwitch.hidden-phone').find('.is-active').data('count');
    if (desktopView && desktopView != parseInt(boostPFSConfig.custom.desktop_row)) {
      jQ(Selector.products + ' .Grid__Cell').removeClass('1/' + boostPFSConfig.custom.tablet_row + '--tablet-and-up 1/' + boostPFSConfig.custom.desktop_row + '--' + buildClass());
      jQ(Selector.products + ' .Grid__Cell').addClass('1/' + desktopView + '--tablet-and-up 1/' + desktopView + '--' + buildClass());
    }
    var mobileView = jQ('.CollectionToolbar__LayoutSwitch.hidden-tablet-and-up').find('.is-active').data('count');
    if (mobileView && mobileView != parseInt(boostPFSConfig.custom.mobile_row)) {
      jQ(Selector.products + ' .Grid__Cell').removeClass('1/' + boostPFSConfig.custom.mobile_row + '--phone');
      jQ(Selector.products + ' .Grid__Cell').addClass('1/' + mobileView + '--phone');
    }

    // Find the grid container
    var grid = document.querySelector('.boost-pfs-filter-products.ProductList--grid');
    if (grid) {
      // Find all product grid items
      var items = grid.querySelectorAll('.Grid__Cell');




      // Insert after the 3rd product (index 2), or wherever you want
      var insertAfter = boostPFSConfig.custom.show_banner_index; // zero-based index
      var insertAfterBannerTwo = boostPFSConfig.custom.show_banner_index_two;



      // 06-08-2025
      if (items.length > insertAfter) {
         let banner_type = boostPFSConfig.custom.banner_type;
         let banner_type_two = boostPFSConfig.custom.banner_type_two;
        const bannerOneAlt = boostPFSConfig.custom.show_banner_headline || boostPFSConfig.custom.show_banner_text || 'Promotional banner';
        const bannerTwoAlt = boostPFSConfig.custom.show_banner_two_headline || boostPFSConfig.custom.show_banner_two_text || 'Promotional banner';

        let fullWidth_two = boostPFSConfig.custom.show_banner_full_width_two ? 'collection-banner-full-width' : '';
        let showShowVideo_two = boostPFSConfig.custom.show_banner_video_two ? 'show-video' : '';

       



        // Create your banner element 1
        if (!grid.querySelector('.promo-one') && banner_type !== "hide" && banner_type) {
          var banner = document.createElement('div');
          banner.className = 'ProductItem Grid__Cell 1/1--phone 1/2--tablet-and-up 1/3--desk 1/3--tablet-and-up promo-banner promo-one ';
          if (banner_type === "image") { 
            banner.innerHTML = `
              <div class="ProductItem">
                <a id="${boostPFSConfig.custom.show_banner_tracking_id}" href="${boostPFSConfig.custom.show_banner_url}" class="ProductItem__ImageWrapper ProductItem__ImageWrapper--withAlternateImage collection-banner">
                  <div class="banner-one-text-wrapper" style="top: ${boostPFSConfig.custom.show_banner_vertical_placement}%; color: ${boostPFSConfig.custom.show_banner_headline_color};">
                    ${boostPFSConfig.custom.show_banner_headline ? `<p class="promo-banner-headline banner-one-headline"> ${boostPFSConfig.custom.show_banner_headline}</p>` : ''}  
                    ${boostPFSConfig.custom.show_banner_text ? `<p class="promo-banner-text banner-one-text">${boostPFSConfig.custom.show_banner_text}</p>` : ''} 
                  </div>
                  <img src="${boostPFSConfig.custom.show_banner_image}" alt="${bannerOneAlt}" style="width: 100%; height: 100%; object-fit: cover; min-height: 220px;" />
                </a>
              </div>
            `;
          }
          else if (banner_type === "video") {
            banner.innerHTML = `
              <div class="ProductItem">
                <a id="${boostPFSConfig.custom.show_banner_tracking_id}" href="${boostPFSConfig.custom.show_banner_url}" class="ProductItem__ImageWrapper ProductItem__ImageWrapper--withAlternateImage collection-banner">
                  <div class="banner-one-text-wrapper" style="top: ${boostPFSConfig.custom.show_banner_vertical_placement}%; color: ${boostPFSConfig.custom.show_banner_headline_color};">
                    ${boostPFSConfig.custom.show_banner_headline ? `<p class="promo-banner-headline banner-one-headline">${boostPFSConfig.custom.show_banner_headline} </p>` : ''}  
                    ${boostPFSConfig.custom.show_banner_text ? `<p class="promo-banner-text banner-one-text">${boostPFSConfig.custom.show_banner_text}</p>` : ''} 
                  </div>
                  <video autoplay muted loop playsinline class="video-banner" style="width: 100%; height: 100%; object-fit: cover; min-height: 220px;" poster="${boostPFSConfig.custom.show_banner_video_poster}">
                       <source src="${boostPFSConfig.custom.show_banner_video_url}" type="video/mp4"> 
                       Your browser does not support the video tag.
                     </video> 
                </a>
              </div>
            `;
          }
          // Only insert if banner_type is not hide and banner exists
          if (items[insertAfter] && banner) {
            items[insertAfter].after(banner);
          }
        }

        // CREATE BANNER TWO
        // Create your banner element 1
        // Only insert banner_two if a .promo-two does not already exist
        if (!grid.querySelector('.promo-two')) {
          var banner_two = document.createElement('div');
          banner_two.className = `ProductItem Grid__Cell 1/1--phone 1/2--tablet-and-up 1/3--desk 1/3--tablet-and-up promo-banner ${fullWidth_two} promo-banner promo-two`;
          if (banner_type_two === "image") {
            banner_two.innerHTML = `
              <div class="ProductItem">
                <a id="${boostPFSConfig.custom.show_banner_tracking_id_two}" href="${boostPFSConfig.custom.show_banner_url_two}" class="ProductItem__ImageWrapper ProductItem__ImageWrapper--withAlternateImage collection-banner">
                  <div class="banner-one-text-wrapper" style="top: ${boostPFSConfig.custom.show_banner_two_vertical_placement}%; color: ${boostPFSConfig.custom.show_banner_two_headline_color};">
                    ${boostPFSConfig.custom.show_banner_two_headline ? `<p class="promo-banner-headline banner-one-headline">${boostPFSConfig.custom.show_banner_two_headline}</p>` : ''}  
                    ${boostPFSConfig.custom.show_banner_two_text ? `<p class="promo-banner-text banner-one-text">${boostPFSConfig.custom.show_banner_two_text}</p>` : ''}
                  </div>
                  <img src="${boostPFSConfig.custom.show_banner_image_two}" alt="${bannerTwoAlt}" style="width: 100%; height: 100%; object-fit: cover; min-height: 220px;" />
                </a>
              </div>
            `;
          } else if (banner_type_two === "video") {
            banner_two.innerHTML = `
              <div class="ProductItem">
                <a id="${boostPFSConfig.custom.show_banner_tracking_id_two}" href="${boostPFSConfig.custom.show_banner_url_two}" class="ProductItem__ImageWrapper ProductItem__ImageWrapper--withAlternateImage collection-banner">
                  <div class="banner-one-text-wrapper" style="top: ${boostPFSConfig.custom.show_banner_two_vertical_placement}%; color: ${boostPFSConfig.custom.show_banner_two_headline_color};">
                    ${boostPFSConfig.custom.show_banner_two_headline ? `<p class="promo-banner-headline banner-one-headline">${boostPFSConfig.custom.show_banner_two_headline}</p>` : ''}  
                    ${boostPFSConfig.custom.show_banner_two_text ? `<p class="promo-banner-text banner-one-text">${boostPFSConfig.custom.show_banner_two_text}</p>` : ''}
                  </div>
                  <video autoplay muted loop playsinline class="video-banner" style="width: 100%; height: 100%; object-fit: cover; min-height: 220px;" poster="${boostPFSConfig.custom.show_banner_video_poster}">
                    <source src="${boostPFSConfig.custom.show_banner_video_url_two}" type="video/mp4"> 
                    Your browser does not support the video tag.
                  </video> 
                </a>
              </div>
            `;
          }
          // Insert after the desired product
          if (items[insertAfterBannerTwo] && banner_two) {
            items[insertAfterBannerTwo].after(banner_two);
          }
        }
       





        // // Insert after the desired product
        // items[insertAfterBannerTwo].after(banner_two); 





      }
    }
  };

  // Build additional elements
  Filter.prototype.afterRender = function(data, eventType) {


    document.dispatchEvent(new CustomEvent('boostFilter:rendered', {
      bubbles: true
    }))


    if (!data) data = this.data;
    if (!eventType) eventType = this.eventType;





  };

  // Build Default layout
  Filter.prototype.errorFilterCallback = function() { var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, isSafari = /Safari/.test(navigator.userAgent), isBackButton = window.performance && window.performance.navigation && 2 == window.performance.navigation.type; if (!(isiOS && isSafari && isBackButton)) { var self = this, url = window.location.href.split("?")[0], searchQuery = self.isSearchPage() && self.queryParams.hasOwnProperty("q") ? "&q=" + self.queryParams.q : ""; window.location.replace(url + "?view=bc-original" + searchQuery) } };
})();



document.addEventListener('DOMContentLoaded', function() {
  // Select all elements with aria-labelledby="Naturgummisål" and add a class to their parent


// Set the aria-labelledby value for multiple domains
var naturalRubberLabel;
var leatherLabel;
if (window.location.hostname.includes('.dk')) {
  naturalRubberLabel = 'Naturgummisål';
  leatherLabel = 'Skindsål';
} else if (window.location.hostname.includes('.com')) {
  naturalRubberLabel = 'Natural Rubber Sole';
  leatherLabel = 'Leather Sole';
} else if (window.location.hostname.includes('.de')) {
  naturalRubberLabel = 'Naturkautschuksohle';
  leatherLabel = 'Ledersohle';
} else if (window.location.hostname.includes('.no')) {
  naturalRubberLabel = 'Naturgummisål';
  leatherLabel = 'Skinnsåle';
} else if (window.location.hostname.includes('.eu')) {
  naturalRubberLabel = 'Natural Rubber Sole';
  leatherLabel = 'Leather Sole';
} else if (window.location.hostname.includes('.uk')) {
  naturalRubberLabel = 'Natural Rubber Sole';
  leatherLabel = 'Leather Sole';  
}


else {
  naturalRubberLabel = 'Natural Rubber sole'; // default fallback
  leatherLabel = 'Leather Sole'; // default fallback
}

// Use the variable in the selector below


  if (window.location.href.includes('siste-sjanse')) {
    // Hide elements with the class 'boost-pfs-filter-option-sal'
    var style = document.createElement('style');
    style.innerHTML = '.boost-pfs-filter-option-sal { display: none !important; }'; 
    if (document.head) {
      document.head.appendChild(style);
    }
  }


  function addSoleClasses() {
    document.querySelectorAll('[aria-labelledby]').forEach(function(el) {
      if (
        el &&
        typeof el.getAttribute === 'function' &&
        el.getAttribute('aria-labelledby') &&
        el.getAttribute('aria-labelledby').includes(naturalRubberLabel)
      ) {
        if (el.parentElement) {
          el.parentElement.classList.add('boost-pfs-filter-button-natural-rubber');
        }
      }
    });

    document.querySelectorAll('[aria-labelledby]').forEach(function(ele) {
      if (
        typeof leatherLabel !== 'undefined' &&
        ele.getAttribute('aria-labelledby') &&
        ele.getAttribute('aria-labelledby').includes(leatherLabel)
      ) {
        if (ele.parentElement) {
          ele.parentElement.classList.add('boost-pfs-filter-button-leather');
        }
      }
    });
  }

 
  if (!window.location.href.includes('siste-sjanse'))  {
    setTimeout(addSoleClasses, 1000);
    // Listen for URL changes (pushState, replaceState, popstate)
    (function() {
    var lastUrl = location.href;
      new MutationObserver(function() {
        if (location.href !== lastUrl) {
          lastUrl = location.href;
          setTimeout(addSoleClasses, 1000);
        }
      }).observe(document, {subtree: true, childList: true});



      // Also listen to popstate

      window.addEventListener('popstate', function() {
        setTimeout(addSoleClasses, 1000);
      });



      // Monkey-patch pushState/replaceState

      ['pushState', 'replaceState'].forEach(function(method) {
        var orig = history[method];
        history[method] = function() {
          var rv = orig.apply(this, arguments);
          setTimeout(addSoleClasses, 1000);
          return rv;
        };
      });
    })();
  }


  document.querySelectorAll('.Linklist__Item a').forEach(function(link) {
    if (link && link.href === window.location.href) {
      link.classList.add('selectedModel');
    }
  });


});

















(function () {
  function syncQuickAddButtons(root = document) {
    const quickAdds = root.querySelectorAll('.js-quick-add--boost');

    quickAdds.forEach((quickAdd) => {
      const trigger = quickAdd.querySelector('.quick-add__open');
      const content = quickAdd.querySelector('.quick-add__content');
      if (!trigger || !content) return;

      if (!content.id) {
        content.id = `quick-add-content-${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;
      }

      trigger.setAttribute('aria-controls', content.id);
      trigger.setAttribute('aria-expanded', quickAdd.classList.contains('open') ? 'true' : 'false');
    });
  }

  function fixAriaCheckboxes(root = document) {
    const buttons = root.querySelectorAll(
      'button[role="checkbox"].boost-pfs-filter-button'
    );

    buttons.forEach((button) => {
      const item = button.closest("li");

      const isSelected =
        button.classList.contains("active") ||
        button.classList.contains("selected") ||
        button.classList.contains("boost-pfs-filter-button-selected") ||
        item?.classList.contains("active") ||
        item?.classList.contains("selected") ||
        item?.classList.contains("boost-pfs-filter-option-item-selected");

      button.setAttribute("aria-checked", isSelected ? "true" : "false");

      if (!button.hasAttribute("aria-label")) {
        const label = button.textContent.trim();
        if (label) button.setAttribute("aria-label", label);
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    syncQuickAddButtons();
    fixAriaCheckboxes();

    document.addEventListener("click", function (event) {
      const quickAddTrigger = event.target.closest('.quick-add__open');
      if (quickAddTrigger) {
        setTimeout(() => {
          syncQuickAddButtons();
        }, 0);
      }

      const button = event.target.closest(
        'button[role="checkbox"].boost-pfs-filter-button'
      );

      if (!button) return;

      setTimeout(() => {
        fixAriaCheckboxes();
      }, 100);
    });

    const observer = new MutationObserver(function (mutations) { 
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            syncQuickAddButtons(node);
            fixAriaCheckboxes(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
})();







